var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-content',[_c('v-list-item-subtitle',[_vm._v("Saldo p/ emissão de contratos")]),_c('v-list-item-title',{staticClass:"font-weight-bold subtitle-1"},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","width":"2","size":"25"}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.saldoDisponivel)+" Kgs")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }